// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DragDropArea_wrap__20Vh6","disabled":"DragDropArea_disabled__2dv3C","btn":"DragDropArea_btn__3Wlwd","count":"DragDropArea_count__3j_80"};